import React, { useEffect, useState } from "react";
import moment from "moment";
import ReactHtmlParser from "react-html-parser";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import * as Assets from "./../../utils/svg_assets";
import * as PageRoutes from "../../utils/route_pages";
import ApiUtils from "../../utils/api_utils";
import { priceDecimal } from "../../utils/utilities";
import { readMore } from "../../utils/utilities";
import BlockReportPage from "../../pages/BlockReportPage";

const Item = (data) => {
  const { data: item } = data;
  const navigate = useNavigate();
  const [remaining, setRemaining] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (item.start) {
      const start = moment(item.start);
      const end = moment(item.end);
      const diff = end.diff(start);
      const diffDuration = moment.duration(diff);

      setRemaining(diffDuration.days());
    }
  }, [item]);

  const handleNavigateDtl = (toPath) => {
    navigate(toPath);
  };

  const RenderQuiz = () => {
    return (
      <>
        <div>
          <Row>
            <Col xs={2} className="mr-small">
              <img src={Assets.iconOval} alt="iconOval" />
            </Col>
            <Col>
              Get up to {priceDecimal(item.object.points)}{" "}
              {item.object.currency.name}
            </Col>
          </Row>
          <Row>
            <Col xs={2}>
              <img src={Assets.iconCalendar} alt="iconCalendar" />
            </Col>
            <Col>{remaining} Days Left</Col>
          </Row>
        </div>
        <div>
          <button type="button" className="btn-danger rounded border-0 p-1 m-1">
            {item.object.have_voted ? "Retake Quiz" : "Take Quiz"}
          </button>
        </div>
      </>
    );
  };

  const RenderSurvey = () => {
    return (
      <>
        <div>
          <Row>
            <Col xs={2} className="mr-small">
              <img
                src={
                  item.object.have_voted
                    ? Assets.iconCheckOrange
                    : Assets.iconOval
                }
                alt="Icon Check Orange"
              />
            </Col>
            <Col>
              {item.object.have_voted ? (
                <span className="font-bold fs-16 text-danger">
                  You have filled survey
                </span>
              ) : (
                `Get ${priceDecimal(item.object.points)} ${
                  item.object.currency.name
                }`
              )}
            </Col>
          </Row>
          {!item.object.have_voted ? (
            <Row>
              <Col xs={2}>
                <img src={Assets.iconCalendar} alt="iconCalendar" />
              </Col>
              <Col>{remaining} Days Left</Col>
            </Row>
          ) : (
            ""
          )}
        </div>
        <div>
          <button
            type="button"
            className={`${
              item.object.have_voted ? "" : "btn-danger "
            } rounded border-0 p-1 m-1`}
          >
            {item.object.have_voted ? "Completed" : "Fill Survey"}
          </button>
        </div>
      </>
    );
  };

  const RenderLikeComment = () => {
    return (
      <>
        <div className="text-secondary font-light mb-2">
          <span className="mx-c-1">
            <img src={Assets.iconLikeSolid} alt="iconLikeSolid" />
            &nbsp;{item.total_like}
          </span>
          <span>
            <img src={Assets.iconCommentSolid} alt="iconCommentSolid" />
            &nbsp;{item.total_comment}
          </span>
        </div>
      </>
    );
  };

  const RenderPolling = () => {
    return (
      <>
        <div>
          <Row>
            <Col xs={2} className="mr-small">
              <img
                src={
                  item.object.have_voted
                    ? Assets.iconCheckOrange
                    : Assets.iconOval
                }
                alt="Icon Check Orange"
              />
            </Col>
            <Col>{`Get ${priceDecimal(item.object.points)} ${
              item.object.currency.name
            }`}</Col>
          </Row>
        </div>
        <div>
          <button
            type="button"
            className={`${
              item.object.have_voted ? "" : "btn-danger "
            } rounded border-0 p-1 m-1`}
          >
            {item.object.have_voted ? "See Result" : "Vote Poll"}
          </button>
        </div>
      </>
    );
  };

  const RenderEvent = () => {
    return (
      <>
        <div>
          <Row className="d-flex align-items-center">
            <Col xs={2} className="fs-18 font-bold text-center mr-1">
              <div>{moment(item.object.start).format("D")} </div>
              <div>{moment(item.object.start).format("MMM")}</div>{" "}
            </Col>
            <Col xs={9} className="mt-3">
              <div className="mb-1 fs-18 font-bold">{item.object.name}</div>
              <div>
                {ReactHtmlParser(readMore(item.object.description, 100))}
              </div>
            </Col>
          </Row>
        </div>
        <div>
          <button className="btn btn-danger border-0">Checkin</button>
        </div>
      </>
    );
  };

  return (
    <div className="has-bottom">
      <div className="card-feeds">
        <div className="d-flex justify-content-between align-items-center m-3">
          <div className="d-flex">
            <div className="mr-1">
              <img
                src={ApiUtils.validateImgUrl({ url: item.creator.image })}
                className="circular-image"
                alt="avatar"
              />
            </div>
            <div className="leading-4 -ml-9">
              <div className="font-bold">{item.creator.name}</div>
              <div className="text-sm">
                Posted a{" "}
                {item.object !== null && item.object.type === "quiz"
                  ? "quiz"
                  : item.object !== null && item.object.type === "survey"
                  ? "survey"
                  : item.is_news
                  ? "news"
                  : item.object !== null && item.object.type === "announcement"
                  ? "announcement"
                  : item.object !== null && item.object.type === "polling"
                  ? "polling"
                  : item.object !== null && item.object.type === "event"
                  ? "event"
                  : null}
              </div>
            </div>
          </div>
          <div className="d-flex items-center">
            <div className="mr-xs">
              {item.created ? moment(item.created).format("LL") : null}
            </div>
            {item.is_news ? (
              <img src={Assets.dot} onClick={() => setIsOpen(true)} />
            ) : (
              ""
            )}
          </div>
        </div>

        <div
          onClick={() => {
            if (item.object !== null && item.object.type === "quiz") {
              handleNavigateDtl(
                `/quiz/${item.object.quiz_category.id}/${item.object.id}`
              );
            } else if (item.object !== null && item.object.type === "survey") {
              if (!item.object.have_voted)
                handleNavigateDtl(`/survey/${item.object.id}`);
            } else if (
              item.object !== null &&
              item.object.type === "announcement"
            ) {
              handleNavigateDtl(`/announcement/${item.object.id}`);
            } else if (item.object !== null && item.object.type === "event") {
              handleNavigateDtl(
                `${PageRoutes.eventDetail}/${item.object.id}?type=is_today`
              );
            } else if (item.object !== null && item.object.type === "polling") {
              handleNavigateDtl(`/polling/${item.object.id}`);
            } else {
              handleNavigateDtl(`${PageRoutes.detailNews}/${item.id}`);
            }
          }}
        >
          <div>
            {item.vid_thumb && item.video ? (
              <div
                className="mr-1 w-100"
                style={{
                  backgroundSize: "cover",
                  height: 170,
                  backgroundPosition: "center",
                  backgroundImage: `url(${ApiUtils.validateImgUrl({
                    url: item.vid_thumb,
                  })}`,
                }}
              ></div>
            ) : Object.keys(item.images).length > 0 ? (
              <div
                className="mr-1 w-100"
                style={{
                  backgroundSize: "cover",
                  height: 170,
                  backgroundPosition: "center",
                  backgroundImage: `url(${ApiUtils.validateImgUrl({
                    url: item?.images?.img?.display,
                  })}`,
                }}
              ></div>
            ) : item.is_news || item?.object?.type === "polling" ? (
              ""
            ) : item.object !== null &&
              (item.object.type === "announcement" ||
                item.object.type === "event") ? (
              <div
                className="mr-1 w-100"
                style={{
                  backgroundSize: "cover",
                  position: "relative",
                  height: 170,
                  backgroundPosition: "center",
                  backgroundImage: `url(${ApiUtils.validateImgUrl({
                    url: item?.object?.image?.thumbnail,
                  })}`,
                }}
              >
                {item.object && item.object.type === "event"
                  ? /*(
                <span className="badge-payment-type">Free</span> // hide because object payment_type not provide
              )*/ ""
                  : ""}
              </div>
            ) : (
              <img className="w-100" src={Assets.bgQuiz} alt="bg quiz" />
            )}
          </div>
          <div className="m-3">
            <div className="text-lg font-bold mb-3">{item.title}</div>
            <div className="text-base font-light">
              {item.description
                ? ReactHtmlParser(readMore(item.description, 100))
                : ""}
            </div>
          </div>
          <div className="d-flex justify-content-between m-2 align-items-center">
            {item.object !== null && item.object.type === "quiz" ? (
              <RenderQuiz />
            ) : item.object !== null && item.object.type === "survey" ? (
              <RenderSurvey />
            ) : item.is_news ? (
              <RenderLikeComment />
            ) : item.object !== null && item.object.type === "polling" ? (
              <RenderPolling />
            ) : item.object !== null && item.object.type === "event" ? (
              <RenderEvent />
            ) : (
              ""
            )}
          </div>
          <div>
            {item.object !== null && item.object.type === "polling" ? (
              <RenderLikeComment />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>

      {isOpen ? (
        <BlockReportPage
          params={{
            type: "feed",
            id: item.id,
            creator: item.creator.id,
            creatorName: item.creator.name,
          }}
          onClose={() => setIsOpen(false)}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default Item;
